import { render, staticRenderFns } from "./M5.vue?vue&type=template&id=931fecc4&scoped=true"
import script from "./M5.vue?vue&type=script&lang=js"
export * from "./M5.vue?vue&type=script&lang=js"
import style0 from "./M5.vue?vue&type=style&index=0&id=931fecc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931fecc4",
  null
  
)

export default component.exports